/* global HTMLElement */ import React from "react";
import classNames from "classnames";
import playerReducers from "../../reducers";
import { createStore } from "redux";
import { Provider } from "react-redux";
import Icon from "../Icon";
import * as ReactDOMServer from "react-dom/server";
function emulateSlide(node, element, props) {
    var _node_target_type;
    var intl = props.intl;
    var mockStore = createStore(playerReducers, {
        cbook: {
            icon_url: props.iconURL
        }
    });
    var disableVisitedIndicator = element.classList.contains("slide-link-emulated__disableVisitedIndicator");
    var disableFavouriteButton = element.classList.contains("slide-link-emulated__disableFavouriteButton");
    var classes = classNames("chart-menu__link", {
        "chart-menu__link--active": props.isCurrentSlide,
        "chart-menu__link--do-not-track": node.do_not_track,
        "chart-menu__link--disabled": !props.isAvailable
    });
    var slideClasses = classNames("chart-menu__item", {
        "chart-status__visited": props.isVisited,
        "chart-status__not-visited": !props.isVisited
    }, "chart-type__".concat(node === null || node === void 0 ? void 0 : (_node_target_type = node.target_type) === null || _node_target_type === void 0 ? void 0 : _node_target_type.toLowerCase()), props.examStatus && "exam-status-".concat(props.examStatus.replace(" ", "-")));
    var visClasses = classNames("chart-menu__visited", {
        "chart-menu__visited--active": props.isVisited
    });
    var favClasses = classNames("chart-menu__fav-btn", {
        "chart-menu__fav-btn--active": props.isFav
    });
    var chartNode = // FIXME: since Icon relies on redux, we need to provide a mock store with the icon_url
    /*#__PURE__*/ React.createElement(Provider, {
        store: mockStore
    }, /*#__PURE__*/ React.createElement("div", {
        className: "chart-menu open"
    }, /*#__PURE__*/ React.createElement("div", {
        className: slideClasses
    }, !disableVisitedIndicator && !node.do_not_track && props.isVisited && /*#__PURE__*/ React.createElement("span", {
        className: visClasses,
        "data-testid": "visited-icon",
        "aria-hidden": true
    }, /*#__PURE__*/ React.createElement(Icon, {
        iconURL: props.iconURL,
        name: "checkmark-bold",
        size: "s"
    })), /*#__PURE__*/ React.createElement("a", {
        href: "?chart=".concat(node.id),
        "data-index": props.slideIndex,
        className: classes
    }, /*#__PURE__*/ React.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: node.name
        }
    }), props.isVisited && /*#__PURE__*/ React.createElement("span", {
        className: "sr-only",
        "data-testid": "viewed"
    }, intl.formatMessage({
        id: "ui.viewed",
        defaultMessage: "Viewed"
    }))), !disableFavouriteButton && /*#__PURE__*/ React.createElement("span", {
        className: favClasses,
        "aria-label": props.isFav ? intl.formatMessage({
            id: "ui.is_favourite",
            defaultMessage: "Is favourite"
        }) : null,
        "data-testid": "fav-icon"
    }, props.isFav ? /*#__PURE__*/ React.createElement(Icon, {
        iconURL: props.iconURL,
        name: "star-fill",
        size: "s"
    }) : /*#__PURE__*/ React.createElement(Icon, {
        iconURL: props.iconURL,
        name: "star-outline",
        size: "s"
    })))));
    // FIXME: react-redux relies on useLayoutEffect which is not available on ReactDOMServer
    element.innerHTML = ReactDOMServer.renderToString(chartNode);
}
export default emulateSlide;
